import styled from 'styled-components';
import theme from '../../../../theme';

const Container = styled.div`
    width: calc(100% - 40px);

    div:nth-child(1) {
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
            height: 25px;
        }

        svg {
            cursor: pointer;
        }
    }

    div:nth-child(2) {
        display: flex;
        flex-direction: column;
        margin: 20px 0;

        label:nth-child(1) {
            font-size: 12px;
            font-weight: 400;
            color: ${theme.textDark};
        }

        label:nth-child(2) {
            font-size: 16px;
            font-weight: 700;
            color: ${theme.textDark};
        }
    }
`;

export { Container };